import { useRouteError } from 'react-router';
import { useEffect } from 'react';
import { ErrorFallback } from '@/components/ErrorBoundary';

/**
 * React Router errorElement — catches route-level errors.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    console.error('[RouteErrorBoundary]', error);
  }, [error]);

  return <ErrorFallback />;
}
